import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Resources = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">Useful Resources for Authors
    </h2>
    <hr />
  
    <ul className="joab-common-para my-4">
        <li>Green Publication Author Services</li>
        <li>Reference list and citations style guide</li>
        <li>Article Processing Charges (APC)</li>
        <li>Terms of Use</li>
        <li>Terms and Conditions</li>
        <li>Policy regarding corrections and retractions</li>
        <li>Statement on controversial articles</li>
    </ul>


  </Container>
  );
};

export default Resources;
